import classNames from "classnames";
import { createUseStyles } from "react-jss";
import Card from "../../../Components/Card";

interface Props {
  id?: string;
  className?: string;
  content?: React.ReactNode;
  image?: string;
  flip?: boolean;
}

const useStyles = createUseStyles({
  root: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    "@media (max-width: 1024px)": {
      flexDirection: "column-reverse !important",
      "& img": {
        marginBottom: "30px",
      },
    },
  },
  left: {
    flexBasis: "48%",
  },
  right: {
    flexBasis: "48%",
  },
  image: {
    width: "100%",
  },
  comingSoonLabel: {
    borderRadius: "100px",
    border: "3px solid #17ade1",
    padding: "14px 20px",
    fontWeight: "bold",
    marginBottom: "30px",
  },
});

const ImageTextCard = ({
  id,
  className,
  content,
  image,
  flip = false,
}: Props) => {
  const classes = useStyles();
  return (
    <Card className={className} blank>
      <div
        id={id}
        className={classNames(classes.root)}
        style={{ flexDirection: flip ? "row-reverse" : "row" }}
      >
        <div className={classes.left}>{content}</div>
        <div className={classes.right}>
          {image && (
            <img className={classes.image} alt="image-text-card" src={image} />
          )}
        </div>
      </div>
    </Card>
  );
};

export default ImageTextCard;
